
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/offline",
      function () {
        return require("private-next-pages/features/offline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/offline"])
      });
    }
  